import React, { useState, useEffect } from 'react'
import { Form, Alert, Spinner } from 'react-bootstrap'
import '../../components/kyc/kycStyle.css'
import { validateIdNumber } from '../../utils/Validation'
import FormInput from '../../components/form/FormInput/FormInput'
import FooterButtons from '../../components/form/FooterButtons/FooterButtons'
import TableDataDirectorEnquiry from '../../components/DirectorEnquiry/TableDataDirectorEnquiry'
import NewAndCloseButtons from '../../components/form/NewAndCloseButtons/NewAndCloseButtons'
import {
  INVALID_ID_WARNING,
  RESTRICTED_REPORT,
  PRICELIST,
} from '../../utils/Constants'
import {
  downloadReport,
  handleXpertDirectorLoadReport,
  searchDirector,
} from '../../api/directorEnquiry/directorEnquiry'
import { ReportTypes } from '../../api/apiConstants'
import ScreenLayout from '../../components/layouts/ScreenLayout'
import { useDownloadFile } from '../../hooks/use-download-file'
type DirectorEnquiryProps = {
  setShow: React.Dispatch<React.SetStateAction<boolean>>
  setIsError: React.Dispatch<React.SetStateAction<boolean>>
  setErrorMessage: React.Dispatch<React.SetStateAction<string>>
  initialState: { [key: string]: any }
  setInitialState: React.Dispatch<React.SetStateAction<any>>
  KYCAccess: boolean
}
type xpertDirector = {
  firstname?: string
  surname?: string
  idno?: string
  name?: string
  enquiryID?: string
  enquiryResultID?: string
}
const DirectorEnquiry: React.FC<DirectorEnquiryProps> = ({
  setShow,
  setIsError,
  setErrorMessage,
  KYCAccess,
  initialState,
  setInitialState,
}) => {
  const [isDisabled, setIsDisabled] = useState(false)
  const [idNumber, setIdNumber] = useState('')
  const [reference, setReference] = useState('')
  const [showProgress, setShowProgress] = useState(false)
  const [xpertDirectors, setXpertDirectors] = useState<xpertDirector[]>([])
  const [xpertDirector, setXpertDirector] = useState<xpertDirector>({})
  const [reportId, setReportId] = useState('0')

  const handleStartOver = () => {
    setReference('')
    setReportId('0')
    setShowProgress(false)
    setReference('')
    setIdNumber('')
    setIsDisabled(false)
    setXpertDirectors([])
    setXpertDirector({})
  }

  const loadReport = async (xpertDirector: xpertDirector) => {
    const handleXpertDirectorLoadReportParams = {
      idNumber,
      xpertDirector,
      reference,
      setShowProgress,
      setIsError,
      setErrorMessage,
      setReportId,
      reportTypeId: ReportTypes.CIPCDirectorEnquiryReport.reportTypeId,
      downloadReport,
    }
    handleXpertDirectorLoadReport(handleXpertDirectorLoadReportParams)
  }

  const updateInitialState = () => {
    setInitialState({
      ...initialState,
      directorEnquiry: {
        idNumber: idNumber,
        reference: reference,
        reportId: reportId,
      },
    })
  }

  const { mutate: downloadReport, isLoading: isDownloading } = useDownloadFile(
    '/DirectorEnquiry/download-report',
    reportId,
    ReportTypes.CIPCDirectorEnquiryReport.reportTypeId,
    setIsError,
    setErrorMessage,
  )

  const handleSearch = () => {
    const isValid = validateForm((missingFields) => {
      if (missingFields.length > 0)
        alert(`Please enter ${missingFields.join(', ')}`)
    })
    if (!isValid) return
    const searchDirectorParams = {
      idNumber,
      setShowProgress,
      setIsError,
      setErrorMessage,
      setXpertDirectors,
    }
    updateInitialState()
    searchDirector(searchDirectorParams)
  }

  const validateForm = (handleMissing?: (missingFields: string[]) => void) => {
    const missingFields = []
    if (!validateIdNumber(idNumber)) {
      missingFields.push('ID number')
      if (handleMissing) handleMissing(missingFields)
      setIsDisabled(true)
      return false
    } else {
      setIsDisabled(false)
      return true
    }
  }

  return (
    <ScreenLayout
      price={PRICELIST.DIRECTOR_ENQUIRY}
      headerText="DIRECTOR ENQUIRY"
      subHeaderText="Information about directors registered in South Africa from the very latest data directly provided by the Companies and Intellectual Property Commission (CIPC)."
      sampleReport={'DirectorEnquiry.pdf'}
    >
      {showProgress && (
        <>
          <div className="spinner-container">
            <Spinner
              as="span"
              animation="border"
              variant="dark"
              role="status"
              aria-hidden="true"
            ></Spinner>
            <span> </span>
          </div>
        </>
      )}
      {Object.keys(xpertDirectors).length === 0 && (
        <Form>
          {KYCAccess !== true && <p className="lbl-red">{RESTRICTED_REPORT}</p>}
          <FormInput
            className="mb-3"
            placeHolderText="Unique identity number"
            onChangeHandler={setIdNumber}
            value={idNumber}
            required
          />
          {idNumber !== '' && !validateIdNumber(idNumber) ? (
            <Alert variant="danger" transition={false}>
              {INVALID_ID_WARNING}
            </Alert>
          ) : null}
          <FormInput
            className="mb-3"
            placeHolderText="Search reference (optional)"
            onChangeHandler={setReference}
            value={reference}
          />
          <FooterButtons
            setShow={setShow}
            handleSearch={handleSearch}
            isDisabled={!KYCAccess}
          />
        </Form>
      )}
      {Object.keys(xpertDirectors).length > 0 && (
        <>
          <TableDataDirectorEnquiry
            xpertDirectors={xpertDirectors}
            setXpertDirector={loadReport}
          />
          <NewAndCloseButtons
            handleAction={handleStartOver}
            handleClose={setShow}
          />
        </>
      )}
    </ScreenLayout>
  )
}
export default DirectorEnquiry
